import MapPage from './MapPage'
export default MapPage;